import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 64px;
  display: flex;
  align-items: center;
  flex-direction: column;

  .starfish {
    width: 133px;
    height: 100px;
  }

  p{
    max-width: 600px;
    text-align: center;
    margin-top: 8px;
  }

  .circle-markle{
    margin-top: 32px;
  }

  @media (max-width: 600px){
    margin-top: 32px;
  }

  @media (max-width: 600px){
    margin-top: 32px;
  }
`;






